export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <div>
      <footer className='footer'>&copy;{year} Irina Gastmaier</footer>
    </div>
  );
}
